/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DeleteButton from '../../../components/buttons/actions-button/DeleteButton'
import EditButton from '../../../components/buttons/actions-button/EditButton'
import Spinner from '../../../components/spinner/Spinner'
import { useOutsideClick } from '../../../hooks/useOutsideClick'
import { setIsVisibleModalCar } from '../../../redux/reducers/cars'
import {
  Report,
  setCurrentReport,
  setCurrentReportId,
  setIsVisibleDeleteModalReport,
  setIsVisibleModalReport,
  setReportModalInitialTab,
} from '../../../redux/reducers/reports'
import { reportsSelector } from '../../../redux/selectors/reports-selector'
import { AppDispatch } from '../../../redux/store'
import { getAmount } from '../../../utils/getAmount'
import { getRole } from '../../../utils/getRole'
import {
  getReportStatusLabel,
  isDraftStatus,
  isInTripStatus,
} from '../../../utils/reportStatus'
import {
  getReportPdfLinks,
  hasReportPdfLinks,
} from '../../../utils/reportPdfLinks'
import { ReportPdfMenuItems } from '../../../components/report-pdf-menu/ReportPdfMenu'
import styles from './ReportsResult.module.css'

interface VisibleDropdowns {
  [key: number]: boolean
}

function ReportsResult({
  dateFrom,
  dateTo,
  getEmployees,
  getCars,
  isFiltersVisible = false,
}: any) {
  const dispatch = useDispatch<AppDispatch>()
  const { isDriver } = getRole()
  const [sortField, setSortField] = useState<number | string | null>(null)
  const [sortOrder, setSortOrder] = useState('asc')
  const { reports, isPendingGetReports, reportsSummary } =
    useSelector(reportsSelector)
  const [sortNewReports, setSortNewReports] = useState<any>([])

  const [visibleDropdowns, setVisibleDropdowns] = useState<VisibleDropdowns>({})

  const ref = useOutsideClick(() => {
    const newVisibleDropdowns = Object.keys(visibleDropdowns).reduce(
      (acc, key) => {
        //@ts-ignore
        acc[key] = false
        return acc
      },
      {} as VisibleDropdowns
    )

    setVisibleDropdowns(newVisibleDropdowns)
  })

  const toggleDropdown = (clientId: number) => {
    setVisibleDropdowns((prevVisibleDropdowns) => ({
      ...prevVisibleDropdowns,
      [clientId]: !prevVisibleDropdowns[clientId],
    }))
  }

  const sortReports = (field: number | string) => {
    const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc'
    setSortField(field)
    setSortOrder(order)

    if (field === 'Truck') {
      const sortedReports = [...reports].sort((a, b) => {
        const nameA = a.car?.name || ''
        const nameB = b.car?.name || ''
        if (nameA < nameB) {
          return order === 'asc' ? -1 : 1
        }
        if (nameA > nameB) {
          return order === 'asc' ? 1 : -1
        }
        return 0
      })
      setSortNewReports(sortedReports)
    }

    if (field === 'Employees') {
      const sortedReports = [...reports].sort((a, b) => {
        //@ts-ignore
        if (a.user.name < b.user.name) {
          return order === 'asc' ? -1 : 1
        }
        //@ts-ignore

        if (a.user.name > b.user.name) {
          return order === 'asc' ? 1 : -1
        }
        return 0
      })
      setSortNewReports(sortedReports)
    }

    if (field === 'Date') {
      const sortedReports = [...reports].sort((a, b) => {
        //@ts-ignore
        if (a.date_from < b.date_from) {
          return order === 'asc' ? -1 : 1
        }
        //@ts-ignore

        if (a.date_from > b.date_from) {
          return order === 'asc' ? 1 : -1
        }
        return 0
      })
      setSortNewReports(sortedReports)
    }

    if (field === 'Route') {
      const sortedReports = [...reports].sort((a, b) => {
        //@ts-ignore
        if (a.distance < b.distance) {
          return order === 'asc' ? -1 : 1
        }
        //@ts-ignore

        if (a.distance > b.distance) {
          return order === 'asc' ? 1 : -1
        }
        return 0
      })
      setSortNewReports(sortedReports)
    }

    if (field === 'Expenses') {
      const sortedReports = [...reports].sort((a, b) => {
        //@ts-ignore
        if (a.cost < b.cost) {
          return order === 'asc' ? -1 : 1
        }
        //@ts-ignore

        if (a.cost > b.cost) {
          return order === 'asc' ? 1 : -1
        }
        return 0
      })
      setSortNewReports(sortedReports)
    }

    // if (field === 'Time') {
    //   const sortedReports = [...reports].sort((a, b) => {
    //     const dateAFrom = new Date(a.date_from)
    //     const dateATo = new Date(a.date_to)

    //     const dateBFrom = new Date(b.date_from)
    //     const dateBTo = new Date(b.date_to)

    //     //@ts-ignore
    //     const differenceInMillisecondsA = dateATo - dateAFrom
    //     //@ts-ignore
    //     const differenceInMillisecondsB = dateBTo - dateBFrom

    //     //@ts-ignore
    //     if (differenceInMillisecondsA < differenceInMillisecondsB) {
    //       return order === 'asc' ? -1 : 1
    //     }
    //     //@ts-ignore

    //     if (differenceInMillisecondsA > differenceInMillisecondsB) {
    //       return order === 'asc' ? 1 : -1
    //     }
    //     return 0
    //   })
    //   setSortNewReports(sortedReports)
    // }
  }

  useEffect(() => {
    setSortNewReports(reports)
  }, [reports])

  const unpaidDisplay =
    Number(reportsSummary?.unpaid || 0) +
    Number(reportsSummary?.on_payment || 0)

  const handleEditReport = (item: any) => {
    dispatch(setCurrentReport(item))
    dispatch(setCurrentReportId(item.id))
    dispatch(setIsVisibleModalReport(true))
  }

  const handleOpenReportExpenses = (item: any) => {
    dispatch(setReportModalInitialTab(2))
    handleEditReport(item)
  }

  const handleOpenReportCargosForward = (item: any) => {
    dispatch(setReportModalInitialTab(4))
    handleEditReport(item)
  }

  const handleDeleteReport = (item: any) => {
    dispatch(setCurrentReportId(item.id))
    dispatch(setIsVisibleDeleteModalReport(true))
  }

  const [currentPage, setCurrentPage] = useState(1)
  const reportsPerPage = 50

  const pageCount = Math.ceil(sortNewReports.length / reportsPerPage)

  const indexOfLastReport = currentPage * reportsPerPage
  const indexOfFirstReport = indexOfLastReport - reportsPerPage
  const currentReports = sortNewReports.slice(
    indexOfFirstReport,
    indexOfLastReport
  )

  const paginate = (pageNumber: number) => setCurrentPage(pageNumber)

  const getStatus = (status: any) => getReportStatusLabel(status)

  return (
    <>
      {' '}
      {isPendingGetReports ? (
        <Spinner />
      ) : (
        <>
          {' '}
          <div
            className={classNames(
              'row align-items-center mb-3',
              styles.information,
              isFiltersVisible && styles.informationWithFilters
            )}
          >
            <div className="col-12">
              <h4 className={classNames(styles.h4, styles.reports, 'mb-0')}>
                Путевых ({sortNewReports.length})
              </h4>
            </div>
          </div>
          <div className={classNames('row', styles.totalAmountPanel)}>
            {!isDriver && (
              <div className="col">
                <div
                  className={classNames(
                    styles.colCont,
                    styles.bgGreen,
                    styles.colorWhite
                  )}
                >
                  <div className="row flex-nowrap">
                    <div
                      className={classNames(
                        'col',
                        styles.small2,
                        styles.summaryColSide
                      )}
                    >
                      <p className={styles.small3}>Все грузы</p>
                      <b>
                        <span className={styles.fontBig}>
                          {getAmount(reportsSummary?.total)}
                        </span>{' '}
                        <span className={styles.small3}>р.</span>
                      </b>
                    </div>
                    <div
                      className={classNames(
                        'col',
                        styles.small2,
                        styles.hint,
                        styles.summaryColCenter
                      )}
                      data-tooltip="Неоплаченные счета"
                    >
                      <p className={styles.small3}>Не оплачено</p>
                      <b>
                        <span className={styles.fontBig}>
                          {getAmount(unpaidDisplay)}
                        </span>{' '}
                        <span className={styles.small3}>р.</span>
                      </b>
                    </div>
                    <div
                      className={classNames(
                        'col',
                        styles.small2,
                        styles.hint,
                        styles.summaryColSide
                      )}
                      data-tooltip="Не добавлены в счета"
                    >
                      <p className={styles.small3}>К оплате</p>
                      <b>
                        <span className={styles.fontBig}>
                          {getAmount(reportsSummary?.unbilled)}
                        </span>{' '}
                        <span className={styles.small3}>р.</span>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="col">
              <div className={classNames(styles.colCont, styles.bgRed)}>
                <div className="row flex-nowrap">
                  <div className={classNames('col', styles.small2)}>
                    <p className={styles.small3}>Все расходы</p>
                    <b>
                      <span className={styles.fontBig}>
                        {getAmount(reportsSummary?.all_expenses)}
                      </span>{' '}
                      <span className={styles.small3}>р.</span>
                    </b>
                  </div>
                  <div className={classNames('col', styles.small2)}>
                    <p className={styles.small3}>Транспортные</p>
                    <b>
                      <span className={styles.fontBig}>
                        {getAmount(reportsSummary?.transport_expenses)}
                      </span>{' '}
                      <span className={styles.small3}>р.</span>
                    </b>
                  </div>
                </div>
              </div>
            </div>

            <div className="col">
              <div
                className={classNames(
                  styles.colCont,
                  styles.small2,
                  styles.bgBlue
                )}
              >
                <p className={styles.small3}>Расстояние</p>
                <b className={styles.fontBig}>
                  {getAmount(reportsSummary?.distance)}{' '}
                  <span className={styles.small3}>км</span>
                </b>
              </div>
            </div>
          </div>
          {!!sortNewReports.length ? (
            <div
            // className={styles.tableBigWrapper}
            >
              <div
                className={classNames(
                  styles.docItem,
                  styles.small2,
                  'pl-2 pr-2 mt-4 mb-2'
                )}
              >
                <div className={classNames(styles.row, 'row')}>
                  <div
                    onClick={() => sortReports('item')}
                    className="d-none d-xl-block col-auto col-xl-2"
                  >
                    <span
                      className={classNames(
                        styles.colorGray,
                        styles.tableSortCol,
                        styles.sortDown
                      )}
                    >
                      Выезд
                    </span>
                  </div>
                  <div
                    onClick={() => sortReports('item')}
                    className="d-none d-xl-block col-xl-4"
                  >
                    <span className="color-gray">Машина/Водитель</span>
                  </div>
                  <div
                    onClick={() => sortReports('item')}
                    className={classNames(
                      styles.docMoney,
                      'col-auto col-xl-auto pr-2 d-none d-xl-block'
                    )}
                  >
                    <span className="color-gray table-sort-col">Расходы</span>
                  </div>
                  <div
                    onClick={() => sortReports('item')}
                    className={classNames(
                      styles.docMoney,
                      'col-auto col-xl-auto pr-2 d-none d-xl-block'
                    )}
                  >
                    <span className="color-gray table-sort-col">Грузы</span>
                  </div>
                  <div
                    onClick={() => sortReports('item')}
                    className={classNames(styles.docKm, 'col-auto col-xl-auto')}
                  >
                    <span className="color-gray table-sort-col d-none d-xl-block">
                      Дистанция
                    </span>
                  </div>
                </div>
              </div>
              {currentReports.map((item: Report, index: number) => {
                const getDate = (isoDateString: string) => {
                  const date = new Date(isoDateString)

                  const day = date.getDate().toString().padStart(2, '0')
                  const month = (date.getMonth() + 1)
                    .toString()
                    .padStart(2, '0')
                  const year = date.getFullYear()

                  const formattedDate = `${day}.${month}.${year}`
                  return formattedDate
                }
                return (
                    <div
                      key={item.id}
                      className={classNames(
                        styles.bgWhite,
                        'pl-2 pr-2 mb-3',
                        styles.border10,
                        styles.bxShadow,
                        styles.small2,
                        styles.docItem
                      )}
                    >
                      <div className={classNames(styles.row, 'row')}>
                        <div
                          className={classNames(
                            styles.docStatus,
                            styles.small3,
                            'col-auto col-sm-3 col-md-3 col-lg-3 col-xl-2 pr-2 pt-1 pb-1'
                          )}
                          onClick={() => handleEditReport(item)}
                        >
                          <span
                            className={classNames(
                              'd-inline-block pl-2 pr-2 pt-0 pb-0 mb-1',
                              styles.borderRadius5,
                              isDraftStatus(item.status) ? styles.bgRed : '',
                              isInTripStatus(item.status) ? styles.bgGreen : '',
                              item.status === 'sent' ? styles.bgTurquoise : '',
                              item.status === 'closed' ? styles.bgDarkBlue : ''
                            )}
                          >
                            <b>{item.number || 'Б/Н'}</b>
                          </span>
                          <br />
                          <span
                            className={classNames(
                              'd-inline-block mb-1',
                              isDraftStatus(item.status)
                                ? styles.colorRed
                                : '',
                              isInTripStatus(item.status)
                                ? styles.colorGreen
                                : '',
                              item.status === 'sent'
                                ? styles.colorTurquoise
                                : '',
                              item.status === 'closed' ? styles.colorDark : ''
                            )}
                          >
                            {getStatus(item.status)}
                          </span>
                          <br />
                          {getDate(item.departure)}
                          &nbsp;⊳
                          <br />
                          {item.arrival ? `⊲ ${getDate(item.arrival)}` : null}
                        </div>
                        <div
                          className={classNames(
                            styles.docCar,
                            'col-sm-6 col-md-5 col-lg-5 col-xl-4 pr-2 pt-1 pb-1'
                          )}
                        >
                          <a
                            onClick={() => handleEditReport(item)}
                            className={classNames(
                              styles.avatarLink,
                              'd-flex align-items-center mb-1'
                            )}
                          >
                            <span className={styles.name}>
                              {item.user.name}
                            </span>
                          </a>
                          <a
                            onClick={() => {
                              dispatch(setIsVisibleModalCar(item?.car?.id))
                            }}
                            className="d-block"
                          >
                            {item?.car?.name}
                          </a>
                          {item?.trailer?.name && (
                            <div
                              onClick={() => {
                                dispatch(
                                  setIsVisibleModalCar(item?.trailer?.id)
                                )
                              }}
                              className="mt-0"
                            >
                              Прицеп: <a>{item?.trailer?.name}</a>
                            </div>
                          )}
                        </div>

                        <div
                          className={classNames(
                            styles.docMoney,
                            styles.docMoneyExpenses,
                            'col-sm-2 col-md-2 col-lg-2 col-xl-auto pt-1 pb-sm-1'
                          )}
                        >
                          <div
                            className={classNames(
                              styles.small3,
                              styles.colorLightGray,
                              'd-none d-sm-block d-xl-none'
                            )}
                          >
                            Расходы
                          </div>
                          <a onClick={() => handleOpenReportExpenses(item)}>
                            <b
                              className={classNames(
                                styles.colorRed,
                                styles.nowrap
                              )}
                            >
                              {Number(item.all_expenses ?? 0).toLocaleString(
                                'en',
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }
                              )}{' '}
                              р.
                            </b>
                          </a>
                        </div>
                        <div
                          className={classNames(
                            styles.docMoney,
                            styles.docMoneyCargos,
                            'col-sm-2 col-md-2 col-lg-2 col-xl-auto pt-sm-1 pb-1'
                          )}
                        >
                          <div
                            className={classNames(
                              styles.small3,
                              styles.colorLightGray,
                              'd-none d-sm-block d-xl-none'
                            )}
                          >
                            Грузы
                          </div>
                          <a
                            onClick={() => handleOpenReportCargosForward(item)}
                          >
                            <b
                              className={classNames(
                                isDriver ? styles.colorGray : styles.colorGreen,
                                styles.nowrap
                              )}
                            >
                              {isDriver
                                ? 'Открыть'
                                : `${Number(
                                    item.cargos_total ?? 0
                                  ).toLocaleString('en', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                  })} р.`}
                            </b>
                          </a>
                        </div>
                        <div
                          className={classNames(
                            styles.docKm,
                            'col-auto col-sm-2 col-md-5 col-lg-5 col-xl-auto pt-1 pb-1'
                          )}
                        >
                          <div
                            className={classNames(
                              styles.small3,
                              styles.colorLightGray,
                              'd-block d-xl-none'
                            )}
                          >
                            Дистанция
                          </div>
                          <span className={styles.nowrap}>
                            {item.mileage_after != null &&
                            item.mileage_before != null
                              ? `${(item.mileage_after - item.mileage_before).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} км`
                              : isDraftStatus(item.status)
                                ? ''
                                : 'В пути'}
                          </span>
                        </div>
                        <div
                          className={classNames(styles.docButtons, 'doc-buttons col pt-1 pb-1')}
                          style={{ textAlign: 'right' }}
                        >
                          {hasReportPdfLinks(item) && (
                            <div
                              onClick={() => toggleDropdown(item.id)}
                              className={classNames(
                                styles.dropdown,
                                styles.dropdownLeft,
                                styles.dropdownUp
                              )}
                            >
                              <div
                                className={classNames(
                                  styles.btn,
                                  styles.btnSmall,
                                  styles.btnOutline,
                                  styles.btnIcon,
                                  styles.btnDropdown
                                )}
                              >
                                <i
                                  className={classNames(
                                    styles.icon,
                                    styles.iconDownload
                                  )}
                                />
                              </div>
                              {visibleDropdowns[item.id] && (
                                <div
                                  ref={ref}
                                  className={classNames(
                                    styles.dropdownContent,
                                    styles.small2
                                  )}
                                >
                                  <ReportPdfMenuItems
                                    items={getReportPdfLinks(item)}
                                  />
                                </div>
                              )}
                            </div>
                          )}
                          <EditButton onClick={() => handleEditReport(item)} />
                          {!isDriver && (
                            <DeleteButton
                              onClick={() => handleDeleteReport(item)}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                )
              })}
            </div>
          ) : (
            <div
              style={{ textAlign: 'center' }}
              className={classNames(styles.fontBig, styles.colorGray, 'mb-5')}
            >
              Нет путевых
            </div>
          )}
          <div style={{ textAlign: 'center' }}>
            {Array.from({ length: pageCount }, (_, index) => (
              <span
                className={classNames(
                  styles.pagingBtn,
                  styles.btn,
                  styles.btnSmall,
                  styles.btnBlueOutline,
                  currentPage === index + 1 && styles.activeButton
                )}
                key={index + 1}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </span>
            ))}
          </div>
        </>
      )}
    </>
  )
}

export default ReportsResult
